import { Flex } from '@chakra-ui/react'
import React from 'react'

const Panel = ({
  children,
  id,
  width,
  hideBorder = false
}: {
  children: React.ReactNode
  id?: string
  width?:
    | string
    | {
        base?: string
        sm?: string
        md?: string
        lg?: string
      }
  hideBorder?: boolean
}) => {
  return (
    <Flex
      data-testid="panel-flex"
      bg="white"
      borderRadius="8px"
      border={hideBorder ? 'none' : '1px solid #E4E5E6'}
      overflow="hidden"
      flexDirection="column"
      id={id}
      h="100%"
      w="100%"
    >
      {children}
    </Flex>
  )
}

export default Panel
